import { IModalProps } from "uikit/Modal/types";

import { UserProfileResponseDto, UserResponseDto } from "utils/swagger_react_query";

import { Events } from "./events";

export type TAppEvents = {
  SetGlobalModal: IModalProps;
  RoleHasUpdated: { roleHasUpdated: boolean; userData?: UserProfileResponseDto | null | undefined };
  PromptsWereDisabled: { promptsWereDisabled: boolean };
  SetValidationModal: {
    userInfo: UserResponseDto | null;
    exitDate: string | null;
    onClose?: () => void;
  };
};

export const AppEvents = new Events<TAppEvents>();
